<template>
  <div class="main">
    <div id="app" class="block__width-1200">
      <transition name="fade">
        <div v-show="is_loaded">
          <sHeader></sHeader>
            <router-view @pageStatus="pageLoader"></router-view>
          <sFooter></sFooter>
        </div>
      </transition>
      <div v-if="!is_loaded" class="ic_loader">
        <img src="./assets/images/an_loader.gif">
      </div>
    </div>
  </div>
</template>

<script>

import sHeader from './components/sHeader.vue'
import sFooter from './components/sFooter.vue'
export default {
  name: 'app',
  components: {
    sHeader, sFooter
  },
  data () {
    return {
      is_loaded: false
    }
  },
  methods: {
    pageLoader (status) {
      this.is_loaded = true
    }
  }

}
</script>

<style>
  @import 'assets/css/reset.css';
  @import 'assets/css/font.css';
  @import 'assets/css/styles.css';

</style>



// WEBPACK FOOTER //
// App.vue?59332adc